import { connect } from 'react-redux';

import { selectResources, selectResourcesIsLoading } from '../Resources.selectors';
import ResourcesList from './ResourcesList';

const mapStateToProps = state => ({
  resources: selectResources(state),
  isLoading: selectResourcesIsLoading(state),
});

export default connect(mapStateToProps)(ResourcesList);
